

const tr230 = {
  label: "Kmpatark From Excel",
  pageLabel: "Kmpatark From Excel",
  starting: true,
  url: "tr230",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "parent Branch",
      label: "Parent Branch",
      name: "",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "parentBranch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "parentBranch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Society",
      label: "Society",
      name: "",
      description: "Select Society"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "society-1",
          value: "society-1"
        },
        {
          label: "society-2",
          value: "society-2"
        },
        {
          label: "society-3",
          value: "society-3"
        }
      ],
      placeHolder: "society",
      //   label: "Branch Code",
      name: "society",
      description: "Select society"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "society",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Product",
      label: "Product",
      name: "",
      description: "Enter Product"
    },
    {
      inputType: "autocomplete",
      isRequired: true,
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "product1",
          value: "product1"
        },
        {
          label: "product2",
          value: "product2"
        },
        {
          label: "product3",
          value: "product3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "products",
      description: "Enter 2 digit branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "products",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "File Name",
      label: "File Name",
      name: "",
      description: ""
    },
    {
      inputType: "fileupload",
      tab: "Fileuploder",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      label: "File Name",
      name: "FileName",
      placeholder: {
        type: "text",
        value: "upload files here."
      },
      files: [],
      multiple: true
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "A/c Name",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Gender",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "Caste",
        accessor: "email"
      },
      {
        Header: "Aadhar No.",
        accessor: "mobile"
      },
      {
        Header: "Mobile No",
        accessor: "pfnumber"
      },
      {
        Header: "Shares",
        accessor: "EmployeeID"
      },
      {
        Header: "S/B A/c No",
        accessor: "EmployeeID"
      },
      {
        Header: "Loan A/c No",
        accessor: "EmployeeID"
      },
      {
        Header: "KYC No",
        accessor: "EmployeeID"
      }
    ]
  }
};

export default tr230;
